module.exports = __webpack_public_path__ + "fonts/MyriadPro-Semibold.c694a24.woff";